import {
  NumberInput as MantineNumberInput,
  type NumberInputProps as MantineNumberInputProps,
} from "@mantine/core";
import { type ChangeEvent, type ForwardedRef, forwardRef } from "react";
import type { FieldValues, Path, PathValue } from "react-hook-form";

export type NumberInputProps = MantineNumberInputProps;
type Props<FORM_TYPE extends FieldValues> = {
  onChange?:
    | ((value: number | "") => void)
    | ((
        event: ChangeEvent<Element> | PathValue<FORM_TYPE, Path<FORM_TYPE>>,
      ) => void);
  value?: number | "";
} & Omit<NumberInputProps, "onChange">;

export const NumberInput = forwardRef(function NumberInput<
  FORM_TYPE extends FieldValues,
>(props: Props<FORM_TYPE>, ref: ForwardedRef<HTMLInputElement>) {
  const { ...inputProps } = props;

  const defaultOption: NumberInputProps = {
    radius: "xs",
    // parser: (value) => {
    //   // 全角数字を半角数字に変換する処理を追加
    //   return value.replace(/[０-９]/g, function (s) {
    //     console.log(value);
    //     return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
    //   });
    // },
    // hideControls: true,
    // parser: (value) => parseToExcludeBlanks(value),
    // formatter: (value) => formatToYen(value),
  };
  const option = Object.assign({}, defaultOption, inputProps);
  return <MantineNumberInput {...option} ref={ref} />;
});
